import { __assign, __read, __rest } from "tslib";
import React, { forwardRef, useRef, useState, useEffect } from "react";
import { mergeRefs } from "../_util/merge-refs";
import { Input } from "../input";
import { callBoth } from "../_util/call-both";
import { noop } from "../_util/noop";
import { useConfig } from "../util";
export var TagSelectInput = forwardRef(function TagSelectInput(_a, ref) {
    var value = _a.value, maxWidth = _a.maxWidth, _b = _a.reservedWidth, reservedWidth = _b === void 0 ? 6 : _b, _c = _a.placeholder, placeholder = _c === void 0 ? "" : _c, _d = _a.style, style = _d === void 0 ? {} : _d, _e = _a.onInput, onInput = _e === void 0 ? noop : _e, props = __rest(_a, ["value", "maxWidth", "reservedWidth", "placeholder", "style", "onInput"]);
    var classPrefix = useConfig().classPrefix;
    var inputRef = useRef(null);
    var mirrorRef = useRef(null);
    var _f = __read(useState(0), 2), width = _f[0], setWidth = _f[1];
    var _g = __read(useState(value), 2), fullInputValue = _g[0], setFullInputValue = _g[1];
    useEffect(function () {
        setFullInputValue(value);
    }, [value]);
    useEffect(function () {
        mirrorRef.current.innerText = fullInputValue || placeholder || "";
        var width = mirrorRef.current.clientWidth;
        setWidth(width > maxWidth ? maxWidth : width);
    }, [fullInputValue, maxWidth, placeholder]);
    var handleInput = function (e) { return setFullInputValue(e.currentTarget.value); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Input, __assign({}, props, { value: value, placeholder: placeholder, onInput: callBoth(handleInput, onInput), style: __assign(__assign({}, style), { width: width + reservedWidth }), ref: mergeRefs(ref, inputRef) })),
        React.createElement("span", { ref: mirrorRef, className: classPrefix + "-fz-reset", style: {
                position: "absolute",
                top: -9999,
                left: 0,
                whiteSpace: "pre",
            } })));
});
TagSelectInput.displayName = "TagSelectInput";
//# sourceMappingURL=TagSelectInput.js.map